export const themes = {
    TRANSPARENT: 'TRANSPARENT',
    WHITE: 'WHITE',
    LIGHT: 'LIGHT',
    DARK: 'DARK',
};

export const sizes = {
    TINY: 'TINY',
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
    MEDIUM_LARGE: 'MEDIUM_LARGE',
    LARGE: 'LARGE',
    HUGE: 'HUGE',
    MAX: 'MAX',
};

export const spacings = {
    NONE: 'NONE',
    MICRO: 'MICRO',
    TINY: 'TINY',
    SMALL: 'SMALL',
    MEDIUM: 'MEDIUM',
    LARGE: 'LARGE',
    BIG: 'BIG',
    HUGE: 'HUGE',
    SUPER: 'SUPER',
    JUMBO: 'JUMBO',
};
